// подаем на вход дату , а на выходе имеем число в виде числа и месяц в виде слов

export const dateConverter = (date: Date) => {
    var russianMonthNames = [
        'января',
        'февраля',
        'марта',
        'апреля',
        'мая',
        'июня',
        'июля',
        'августа',
        'сентября',
        'октября',
        'ноября',
        'декабря',
    ];
    // день и месяц по Москве: даты мероприятий московские, а getDate()
    // в поясе браузера западнее Москвы давал предыдущий день
    const [day, month] = date
        .toLocaleDateString('en-GB', {
            timeZone: 'Europe/Moscow',
            day: 'numeric',
            month: 'numeric',
        })
        .split('/')
        .map(Number);
    const russianMonth = russianMonthNames[month - 1];
    const formattedDate = day + ' ' + russianMonth;
    return formattedDate;
};
